<agr-dialog id="request-overview-dialog" [data]="data" (cancel)="cancel()">
  <div
    class="flex--row flex--justify-space-between border-bottom--gray4 header-container spacing--margin-bottom spacing--margin-top"
  >
    <div
      class="text--bold dialog-title-container spacing--margin-top spacing--margin-bottom spacing--margin-left"
    >
      {{ 'slideInDialog.title' | translate }}
    </div>
    <div
      (click)="cancel()"
      class="close-button-container spacing--margin-top spacing--margin-bottom spacing--margin-right"
    >
      {{ 'slideInDialog.close-button' | translate }}
    </div>
  </div>

  <div
    class="spacing--margin-top spacing--margin-bottom text--h3 title-container spacing--margin-left text--bold"
  >
    {{ 'slideInDialog.request.header-text' | translate }}
  </div>
  <div class="bigger-margin text--normal spacing--margin-left spacing--margin-bottom">
    {{ 'slideInDialog.request.sub-header-text' | translate }}
  </div>

  <div
    class="spacing--margin-top spacing--margin-bottom table-container spacing--margin-left spacing--margin-right"
  >
    <table class="table-no-borders flex--column">
      <tr class="flex--row flex--justify-space-between spacing--margin-bottom border-bottom-gray4">
        <td class="text--bold spacing--margin-right">
          {{ 'dashboard.overview-table.table-headers.manureCategory' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ 'manureCategories.' + data.selectedRequest?.manureCategory | translate }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right">
          {{ 'dashboard.overview-table.table-headers.manureType' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ 'manureTypes.' + data.selectedRequest?.manureType | translate }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right">
          {{ 'dashboard.overview-table.table-headers.amountInTons' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ data.selectedRequest?.amountInTons }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right spacing--margin-bottom">
          {{ 'dashboard.overview-table.table-headers.nKgPerTon' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ data.selectedRequest?.nKgPerTon | number }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right spacing--margin-bottom">
          {{ 'dashboard.overview-table.table-headers.maxNitrogen' | translate }}
        </td>
        <td class="max-nitrogen-field spacing--margin-left spacing--margin-bottom">
          @if (data.selectedRequest?.nKgPerTon) {
            {{ data.selectedRequest?.nKgPerTon * data.selectedRequest?.amountInTons | number }}
          }
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right spacing--margin-bottom">
          {{ 'dashboard.overview-table.table-headers.pKgPerTon' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ data.selectedRequest?.pKgPerTon | number }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right spacing--margin-bottom">
          {{ 'dashboard.overview-table.table-headers.maxPhosphate' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom max-phosphate-field">
          @if (data.selectedRequest?.pKgPerTon) {
            {{ data.selectedRequest?.pKgPerTon * data.selectedRequest?.amountInTons | number }}
          }
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right spacing--margin-bottom">
          {{ 'dashboard.overview-table.table-headers.kKgPerTon' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ data.selectedRequest?.kKgPerTon | number }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-rightspacing--margin-bottom">{{
            'dashboard.overview-table.table-headers.homogeneous' | translate
          }}</span>
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          <div>
            @switch (data.selectedRequest?.isHomogeneous) {
              @case (true) {
                <p>{{ 'homogeneity.homogeneous' | translate }}</p>
              }
              @case (false) {
                <p>{{ 'homogeneity.notHomogenous' | translate }}</p>
              }
              @case (null) {
                <p>{{ 'homogeneity.empty' | translate }}</p>
              }
            }
          </div>
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-right">{{
            'dashboard.overview-table.table-headers.distance' | translate
          }}</span>
        </td>
        <td class="spacing--margin-bottom">
          <span class="spacing--margin-left">{{
            'distance.' + data.selectedRequest?.distance | translate
          }}</span>
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-right">{{
            'dashboard.overview-table.table-headers.desiredDeliveryPeriod' | translate
          }}</span>
        </td>
        <td class="spacing--margin-bottom">
          <span class="spacing--margin-left"
            >{{
              data.selectedRequest?.desiredDeliveryPeriodFrom
                ? ('shorthand-months.' + data.selectedRequest?.desiredDeliveryPeriodFrom
                  | translate)
                : ('' | translate)
            }}
            {{
              data.selectedRequest?.desiredDeliveryPeriodFrom &&
              data.selectedRequest?.desiredDeliveryPeriodTo
                ? '-'
                : ''
            }}
            {{
              data.selectedRequest?.desiredDeliveryPeriodTo
                ? ('shorthand-months.' + data.selectedRequest?.desiredDeliveryPeriodTo | translate)
                : ('' | translate)
            }}
          </span>
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-right">{{
            'dashboard.overview-table.table-headers.paymentType' | translate
          }}</span>
        </td>
        <td class="spacing--margin-bottom">
          @if (data.selectedRequest?.paymentType === 'Pay') {
            <span class="you-receive-container text--center">
              {{ 'dashboard.overview-table.paymentType.Receive' | translate }}
            </span>
          } @else {
            <span class="you-pay-container text--center">
              {{ 'dashboard.overview-table.paymentType.Pay' | translate }}
            </span>
          }
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-right">{{
            'dashboard.overview-table.table-headers.pricePerTon' | translate
          }}</span>
        </td>
        <td class="spacing--margin-bottom">
          <span class="spacing--margin-left">{{
            data.selectedRequest?.pricePerTon | currency: 'EUR'
          }}</span>
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-right test">{{
            'dashboard.overview-table.table-headers.price' | translate
          }}</span>
        </td>
        <td class="spacing--margin-bottom">
          <span class="spacing--margin-left total-price-field">{{
            data.selectedRequest?.amountInTons * data.selectedRequest?.pricePerTon | currency: 'EUR'
          }}</span>
        </td>
      </tr>
    </table>

    <div
      class="spacing--margin-top spacing--margin-bottom text--label information-container border-bottom--gray4"
    >
      *{{ 'resume-page.offer.transport-info' | translate }}
    </div>
  </div>

  <div
    class="intermediary-container spacing--margin-top spacing--margin-bottom border-bottom--gray4 spacing--margin-left spacing--margin-right"
  >
    <div class="intermediary-header flex--row">
      <div class="intermediary-text text--bold">
        {{ 'slideInDialog.request.intermediary' | translate }}
      </div>
      <div class="spacing--margin-left intermediary-info-button">
        <mat-icon matTooltip="{{ 'slideInDialog.request.info-button-text' | translate }}"
          >info_outline</mat-icon
        >
      </div>
    </div>

    <div class="intermediary-name spacing--margin-bottom">
      {{ data.selectedRequest?.preferredIntermediary }}
    </div>
  </div>

  <div
    class="action-buttons-container spacing--margin-left spacing--margin-right spacing--margin-bottom"
  >
    <div class="match-button-container spacing--margin-right">
      <agr-primary-action
        [actionText]="'slideInDialog.match-button' | translate"
        actionIcon="add"
        class="spacing--margin-right place-offer-button-container"
        (action)="makeMatch()"
        disabled="!formGroup.valid"
      ></agr-primary-action>
    </div>

    <div
      class="flex--nowrap flex--row flex--align-center flex--justify-center footer-close-button-container"
    >
      <button
        (click)="cancel()"
        class="mat-flat-button mat-focus-indicator mat-button-base footer-close-button"
      >
        <div class="footer-button-text-container">
          {{ 'slideInDialog.close-button' | translate }}
        </div>
      </button>
    </div>
  </div>
</agr-dialog>
